import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import 'bootswatch/dist/flatly/bootstrap.css'


ReactDOM.render(
    <App />,
  document.getElementById('root')
);

